module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_5250_Active@1x-fb2a25e33ffd2b8fb66a136e316d80a5.png";